import { render } from "./AcademicCalendar.vue?vue&type=template&id=08e79cfe&scoped=true"
import script from "./AcademicCalendar.vue?vue&type=script&lang=js"
export * from "./AcademicCalendar.vue?vue&type=script&lang=js"

import "./AcademicCalendar.vue?vue&type=style&index=0&id=08e79cfe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08e79cfe"

export default script